import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {User} from 'projects/core/src/lib/login/data/user';
import {LocalStorage} from 'ngx-webstorage';
import moment from 'moment/moment';
import {SaleStat} from 'projects/app-misc/src/app/modules/reports/data/sale-stat';
import {MultiSelect} from 'primeng/multiselect';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {ReportsService} from 'projects/app-misc/src/app/modules/reports/data/reports.service';
import {UsersService} from 'projects/app-misc/src/app/modules/users/data/users.service';
import {LineChartStore} from 'projects/app-misc/src/app/modules/reports/data/line-chart.store';
import {Router} from '@angular/router';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {MatDialog} from '@angular/material/dialog';
import {ProjectStatReportsComponent} from '../project-stat-reports/project-stat-reports.component';
import {Subject} from 'rxjs';

export class DatePeriod {
  label: string;
  startDate: string;
  finishDate: string;
  defaultView?: DefaultView;
}

class DefaultView {
  label: string;
  name: string;
  service: string;
  dateFormat?: string;
}

@Component({
  selector: 'app-graphs-view',
  templateUrl: './graphs-view.component.html',
  styleUrls: ['./graphs-view.component.scss']
})
@RxJSUnsubscribe
export class GraphsViewComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
  currentUser: User;

  graph: SaleStat[];
  totalGraph: SaleStat;

  users: User[];
  selectedUsers: User[] = [];

  @LocalStorage()
  filteredReportUsers: number[];

  selectedStartDate: Date;
  selectedFinishDate: Date;

  selectedDate: DatePeriod;

  @LocalStorage()
  selectedDateIndex: number;

  charts = [
    'Doughnuts',
    'Chart',
    'Bars'
  ]

  selectedChart: string = this.charts[0];

  dates: DatePeriod[] = this.reportsService.dates

  selectedView: DefaultView;

  @LocalStorage()
  selectedViewIndex: number;

  defaultViews: DefaultView[] = [{
    label: 'by Day',
    name: 'by-day',
    dateFormat: 'D MMM',
    service: 'ByDay',
  }, {
    label: 'by Week',
    name: 'by-week',
    dateFormat: 'D MMM',
    service: 'ByWeek'
  }, {
    label: 'by Month',
    name: 'by-month',
    dateFormat: 'MMMM YYYY',
    service: 'ByDate'
  },]

  graphLoading = true;
  firstLoading = true;

  dateFormat: string;
  // defaultViewString: string;

  usersInfo: SaleStat[] = [];

  reportsSubj = new Subject<void>()

  @ViewChild('multiSelect', {static: true})
  multiSelect: MultiSelect

  constructor(
    private appStateQuery: AppStateQuery,
    protected reportsService: ReportsService,
    private usersService: UsersService,
    private lineChartStore: LineChartStore,
    private dialog: MatDialog,
    public router: Router
  ) {
  }

  ngOnInit(): void {

    this.subToUpdates()

    this.selectedDate = this.dates[1];

    if (this.selectedDateIndex && this.selectedDateIndex >= 0) {
      this.selectedDate = this.dates[this.selectedDateIndex]
    }


    this.selectedStartDate = moment(this.selectedDate.startDate).toDate()
    this.selectedFinishDate = moment(this.selectedDate.finishDate).toDate()

    this.dateFormat = this.selectedDate.defaultView.dateFormat;


    if (this.selectedViewIndex && this.selectedViewIndex >= 0) {
      this.selectedView = this.defaultViews[this.selectedViewIndex]
      this.dateFormat = this.defaultViews[this.selectedViewIndex].dateFormat
    }

    if (typeof this.selectedView === 'undefined') {
      const fView = this.defaultViews.find(view => view.name === this.selectedDate.defaultView.name);
      this.selectedView = fView;
      this.dateFormat = fView.dateFormat;
    }

    this.appStateQuery.currentUser$.subscribe(currentUser => {
      this.currentUser = currentUser;

      this.usersService.getUsersByRoles(0, 50, 'SalesPerson', true).subscribe(users => {
        this.users = [...users.content];
        this.users.push({
          id: -1,
          name: 'Other Users',
          shortCode: 'OU',
          bgColor: 'ff9f1a'
        })
        let selectedUsersIds: number[]

        if (!this.currentUser.adminRole && this.currentUser.adminNSales) {
          this.users = this.users.filter(user => this.currentUser.id === user.id)
        }


        if (!this.filteredReportUsers) {
          this.selectedUsers = [...this.users]
          selectedUsersIds = this.selectedUsers.map(column => column.id)
        } else {
          const uIds = this.users.map(user => user.id)
          const fUIds = this.filteredReportUsers;
          const usersMap = new Map(this.users.map(usr => [usr.id, usr]));

          selectedUsersIds = uIds.filter(x => !fUIds.includes(x));
          this.selectedUsers = selectedUsersIds.map(id => usersMap.get(id));
        }

        if (selectedUsersIds) {
          this.filteredReportUsers = this.users.map(cols => cols.id).filter(colId => !selectedUsersIds.includes(colId));
        }

        this.lineChartStore.updateSelectedUsers(this.selectedUsers)
        this.lineChartStore.updateDateFormat(this.dateFormat)
        this.lineChartStore.updateDates(this.selectedDate)

        this.lineChartStore.updateLoading(true);
        this.reportsSubj.next();

        // this.selectedUser = this.users.find(user => user.id === this.currentUser.id);
      })
    });

    this.chartChanged()
  }

  updateManagers() {
    const selectedColumnsIds = this.selectedUsers.map(col => col.id)

    this.filteredReportUsers = this.users.map(user => user.id).filter(userId => !selectedColumnsIds.includes(userId));

    this.lineChartStore.updateSelectedUsers(this.selectedUsers)

    this.lineChartStore.updateLoading(true);
    this.reportsSubj.next();
  }

  updateDate(event) {
    if ((event.value as DatePeriod).defaultView.dateFormat) {
      this.dateFormat = (event.value as DatePeriod).defaultView.dateFormat;
      this.selectedView = this.defaultViews.find((view, index) => {
        if (view.name === this.selectedDate.defaultView.name) {
          this.selectedViewIndex = index
          return view
        }
      });
    }

    const fIndex = this.dates.findIndex(date => date.label === event.value.label)

    if (fIndex) {
      this.selectedDateIndex = fIndex;
    }

    this.selectedStartDate = moment(this.selectedDate.startDate).toDate()
    this.selectedFinishDate = moment(this.selectedDate.finishDate).toDate()


    this.lineChartStore.updateDateFormat(this.dateFormat)
    this.lineChartStore.updateDates(this.selectedDate)

    this.lineChartStore.updateLoading(true);
    this.reportsSubj.next();
  }

  updateView(event) {
    if ((event.value as DefaultView)) {
      this.dateFormat = (event.value as DefaultView).dateFormat;
    }

    const fIndex2 = this.defaultViews.findIndex(view => view.label === this.selectedView.label);

    if (fIndex2 >= 0) {
      this.selectedViewIndex = fIndex2
    }

    this.lineChartStore.updateDateFormat(this.dateFormat)

    this.lineChartStore.updateLoading(true);
    this.reportsSubj.next();
  }

  subToUpdates() {
    this.reportsSubj.pipe(takeUntil(this.getUnsubFromAllSubs()), debounceTime(250)).subscribe(() => {

      const start = moment(this.selectedStartDate).format('YYYY-MM-DD');
      const finish = moment(this.selectedFinishDate).format('YYYY-MM-DD');


      const selectedUsersIds = this.selectedUsers.map(col => col.id)

      this.reportsService.getGraphByDate2(start, finish, this.selectedView.name, selectedUsersIds).subscribe(data => {
        this.lineChartStore.updateEvents(data)
        this.graph = [...data];


        // Pop Acadia total report
        this.totalGraph = this.graph.pop()

        this.fillUsersInfo();
        if (this.currentUser.adminRole) {
          this.fillAcadiaInfo();
        }


        this.graphLoading = false;
        this.firstLoading = false;
      })


    })
  }

  fillUsersInfo() {
    this.usersInfo = [];

    const userMap = new Map<number, SaleStat>()

    this.selectedUsers.forEach(user => {
      userMap.set(user.id, {
        salesUser: user,
        invoicedBalance: 0,
        totalAmt: 0,
        paymentsReceived: 0,
        unBilledAmount: 0,
      })
    })

    this.graph.forEach(userReport => {

      if (userMap.has(userReport.salesUser.id)) {
        const mapUser = userMap.get(userReport.salesUser.id)

        mapUser.totalAmt = userReport.totalAmt
        mapUser.invoicedBalance = userReport.invoicedBalance
        mapUser.paymentsReceived = userReport.paymentsReceived
        mapUser.unBilledAmount = userReport.unBilledAmount
      }
    })

    userMap.forEach((val) => {
      this.usersInfo.push(val)
    })

  }

  fillAcadiaInfo() {
    const companyTotalInfo = {
      salesUser: {
        id: -99,
        name: 'Acadia Craft',
        bgColor: 'ff9f1a',
      },
      totalAmt: this.totalGraph.totalAmt,
      invoicedBalance: this.totalGraph.invoicedBalance,
      paymentsReceived: this.totalGraph.paymentsReceived,
      unBilledAmount: this.totalGraph.unBilledAmount,
      hideUser: false
    }

    this.usersInfo.push(companyTotalInfo)
  }

  showAll() {
    this.multiSelect.toggleAll({})
  }

  dateChange() {
    if (moment(this.selectedFinishDate).diff(this.selectedStartDate, 'months') === 0) {
      this.dateFormat = 'D MMM';
      this.selectedView = this.defaultViews[0]
      this.selectedViewIndex = 0;
    }

    this.selectedDate = this.dates[0]
    this.selectedDateIndex = 0;

    this.lineChartStore.updateDateFormat(this.dateFormat)
    this.lineChartStore.updateDates(this.selectedDate)

    this.lineChartStore.updateLoading(true);
    this.reportsSubj.next();
  }

  blurActiveElement() {
    setTimeout(() => {
      let activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement)
        activeElement.blur()
    }, 5);
  }


  monthChange() {
    this.dateFormat = 'D MMM';
    this.selectedView = this.defaultViews[0]
    this.selectedViewIndex = 0;

    const start = moment(this.selectedStartDate).startOf('month').format('YYYY-MM-DD');
    const finish = moment(this.selectedStartDate).endOf('month').format('YYYY-MM-DD');

    this.selectedStartDate = moment(start).toDate();
    this.selectedFinishDate = moment(finish).toDate();

    this.lineChartStore.updateDateFormat(this.dateFormat)

    this.lineChartStore.updateDates({
      label: this.selectedDate.label,
      startDate: start,
      finishDate: finish,
      defaultView: this.selectedDate.defaultView
    })

    this.lineChartStore.updateLoading(true);
    this.reportsSubj.next();
  }

  minusMonth() {
    this.selectedStartDate = moment(this.selectedStartDate).subtract(1, 'M').toDate();

    this.monthChange();
  }

  plusMonth() {
    this.selectedStartDate = moment(this.selectedStartDate).add(1, 'M').toDate();

    this.monthChange();
  }

  chartChanged() {
    this.lineChartStore.updateChartType(this.selectedChart)
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  openReport() {
    this.dialog.open(ProjectStatReportsComponent, {
      data: {
        startDate: moment(this.selectedStartDate).format('YYYY-MM-DD'),
        finishDate: moment(this.selectedFinishDate).format('YYYY-MM-DD')
      },
      panelClass: 'project-stat-reports',
      disableClose: false
    });
  }

  ngOnDestroy() {

  }
}
